import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from 'seagull/components/Typography';
import { getTestIds } from 'seagull/utils/TestIds';
import { draftLogicTextsPath } from '~/business-logic/draftLogic';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useValidationRules } from '~/hooks/useValidationRules/useValidationRules';
import { useLocaleKeys } from '~/i18n';
import { SigningPolicyType } from '~/types/api.model';
import EditableTableCell from '../../EditableTableCell/EditableTableCell';
import { clientAdditionalRecipientsModalOptions, recipientsCellAvailability } from './AdditionalRecipientsCell.utils';
export const GetAdditionalRecipientsCellTID = (parentTestId)=>getTestIds(parentTestId);
export function AdditionalRecipientsCell(param) {
    let { draft, contact, index, onOpenModal, isDisabled, disabledTooltip } = param;
    const { AdditionalRecipientsCellTestIds } = GetAdditionalRecipientsCellTID();
    const { t: draftCellsTexts } = useLocaleKeys('proposal.draftsDashboard.cells');
    const { t: validationTexts } = useLocaleKeys(draftLogicTextsPath);
    const validators = useValidationRules();
    const { ANY_ONE_SIGN } = useFeatureFlags();
    const numReviewers = draft.reviewers().length;
    const availability = recipientsCellAvailability({
        draft,
        contact,
        isDisabled,
        disabledTooltip,
        draftCellsTexts: draftCellsTexts.draft
    });
    const openRecipientsModal = ()=>{
        var _draft_signingPolicy;
        return onOpenModal(clientAdditionalRecipientsModalOptions({
            title: draftCellsTexts.draft.additionalRecipients(),
            testId: AdditionalRecipientsCellTestIds.ClientModal(),
            primaryContact: contact || undefined,
            anyOneSigns: !!ANY_ONE_SIGN && ((_draft_signingPolicy = draft.signingPolicy()) === null || _draft_signingPolicy === void 0 ? void 0 : _draft_signingPolicy.type) === SigningPolicyType.AnySigner,
            validationTexts,
            validators
        }));
    };
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: AdditionalRecipientsCellTestIds.Root(index),
        isDisabled: availability.isDisabled,
        disabledTooltip: availability.disabledTooltip,
        onClick: openRecipientsModal,
        children: /*#__PURE__*/ _jsx(Typography, {
            testId: AdditionalRecipientsCellTestIds.Count(index),
            skin: numReviewers ? 'standard' : 'secondary',
            children: numReviewers ? draftCellsTexts.shared.additionalRecipientsCount({
                count: numReviewers
            }) : draftCellsTexts.shared.notSet()
        })
    });
}
